import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'utils/WebUtils';

import { withStyles } from '@material-ui/core/styles';
import { withCookies } from "react-cookie";
import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth';
import { LinearProgress, Typography, Collapse, IconButton } from '@material-ui/core';
import Sidenav from 'layouts/components/sidenav/sidenav.component';
import MstrLogout from 'containers/reports/MstrLogout'
import MenuSidenavCompact from 'layouts/components/menu-sidenav-compact/menu-sidenav-compact.component';
import {
    currentOrganization,
    currentUser,
    userOrganizations
} from 'redux/selectors/user.selector';
import CloseIcon from '@material-ui/icons/Close';

import EntitySelectors from "redux/selectors";

// Actions
import { toggleSidenav, setSidenavOpen, toggleSidenavVariant } from 'redux/actions/layout.actions';

import scss from './layout-compact.module.scss';
import styles from './layout-compact.style';
import TourWindow from '../../components/Tour/TourWindow';
import Notification from '../../containers/Notification';
import UpgradeSplashDialog from "../../components/UpgradeSplash";
import {
    getClientSSPFields,
    joyRide,
    showImportDialog,
    autoSync,
    showUpgradeDialog,
    triggerTour
} from "redux/selectors/data.selector";

import { setData2 } from "redux/actions/data.actions";
import Joyride from "react-joyride";

import { allTours } from "../../components/Tour/JoyRideConfig";
import Alert from "@material-ui/lab/Alert/Alert";
import { getPlan, getTrial } from "utils/auth";
import * as WebUtils from "utils/WebUtils";
import IntegrationSyncForm from "containers/sync/sync-search/IntegrationSyncForm";
import { withRouter } from "react-router-dom";
import { updateOrganizationAttribute } from "rest/API";
import {
    Settings
} from '@material-ui/icons';
const notificationSelectors = EntitySelectors.notification;


class CompactLayout extends React.Component {
    // Set the initial layout state when the layout is initialised
    constructor(props) {
        super(props);
        const variant = isWidthDown('sm', props.width) ? 'temporary' : 'persistent';
        props.toggleSidenavVariant(variant);
        props.setSidenavOpen(variant === 'persistent');
    }

    setJoyrideCallback = (callback) => {
        const { type, status } = callback;

        if (type == "tour:end" && status == "finished")
            setData2("currentJoyRide", null);
    }

    setJoyrideHelpers = (helpers) => {
        this.joyRideHelpers = helpers;
    }

    // Update the layout state when a going from mobile to desktop and vice versa
    componentWillReceiveProps(nextProps) {
        if ((isWidthDown('sm', this.props.width) && isWidthUp('md', nextProps.width))) {
            this.props.toggleSidenavVariant('persistent');
            this.props.setSidenavOpen(true);
        } else if ((isWidthDown('sm', nextProps.width) && isWidthUp('md', this.props.width))) {
            this.props.toggleSidenavVariant('temporary');
            this.props.setSidenavOpen(false);
        }

        if (this.props.joyRide !== nextProps.joyRide)
            this.joyRideHelpers && this.joyRideHelpers.reset && this.joyRideHelpers.reset(true);
    }


    handleHideAlert = async (e) => {
        e.stopPropagation();
        const { currentOrganization, patchOrganization, classes } = this.props;
        if ((currentOrganization.currentPeriod == undefined || null) && currentOrganization.setupIncomplete) {
            WebUtils.showAlert({
                content: (<Typography variant={'body1'}>{'To get out of setup / restatement mode you must close your first accounting period. '}
                    <a href='https://www.chargebee.com/docs/revrec/journal-account-mapping.html' target="_blank" className={classes.linkCss}>{'Learn How'}</a>
                </Typography>),
                title: '',
                icon: "warning",
            });
        } else {
            setData2("showUpgradeDialog", null)
            const org =
                await updateOrganizationAttribute(currentOrganization.id, { setupIncomplete: false });
            patchOrganization(org)
        }
    }

    handleAlertClick = async (e, isTrial) => {
        e.stopPropagation();
        if (isTrial)
            setData2("showUpgradeDialog", "plan")
    }

    render() {
        const {
            children,
            classes,
            showUpgradeDialog,
            showImportDialog,
            autoSync,
            sspFields,
            history,
            cookies,
            ...rest
        } = this.props;

        const { triggerTour, joyRide, userOrganizations, currentOrganization, steps, currentUser } = rest;
        const appModeResponse = cookies.get('appModeResponse');
        if (!userOrganizations || !userOrganizations.length || !currentOrganization)
            return <LinearProgress />

        const activePlan = getPlan();
        const { isTrial, daysRemaining } = getTrial(activePlan);
        const setupIncomplete = currentOrganization && currentOrganization.setupIncomplete;

        return (
            <div className={classNames(scss['layout-compact-wrapper'], classes.wrapper)}>
                <Sidenav {...rest}>
                    <MenuSidenavCompact id={'menu'} />
                </Sidenav>
                <main id='main-layout' className={scss['layout-compact-main']}>
                    {isTrial &&
                        <Alert classes={{ root: classes.warning, message: classes.alertMessage }}
                            severity="warning"
                            onClick={(e) => this.handleAlertClick(e, isTrial)}
                            onClose={this.handleHideAlert}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {isTrial &&
                                    <span>You have {daysRemaining} days left in your trial</span>
                                }
                            </div>
                        </Alert>
                    }
                    {appModeResponse && appModeResponse.mode == 'r' &&
                        <Alert icon={<Settings style={{ color: 'grey' }} />} severity="info" classes={{ root: classes.info }}>
                            The system is currently undergoing maintenance.
                        </Alert>
                    }

                    <div className={scss['layout-compact-content-wrapper']}>
                        <div className={scss['layout-compact-content']}>
                            <Notification />
                            {children}
                        </div>
                    </div>
                </main>
                <TourWindow open={triggerTour} />
                <UpgradeSplashDialog open={!!showUpgradeDialog}
                    type={showUpgradeDialog}
                    onClose={() => setData2("showUpgradeDialog", null)}
                />
                <Joyride
                    callback={this.setJoyrideCallback}
                    getHelpers={this.setJoyrideHelpers}
                    continuous={true}
                    run={joyRide}
                    steps={steps}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    styles={{
                        options: {
                            primaryColor: "#6200ea"
                        }
                    }}
                />
                <IntegrationSyncForm
                    visible={showImportDialog}
                    autoSync={autoSync}
                    onClose={() => setData2("showImportDialog", null)}
                    user={currentUser}
                />
                <MstrLogout />
            </div>
        );
    }
}


function mapStateToProps(state) {
    const currentRide = joyRide(state);

    const toReturn = {
        layout: {
            sidenavOpen: state.layout.sidenavOpen
        },
        triggerTour: triggerTour(state),
        organizations: userOrganizations(state),
        currentOrganization: currentOrganization(state),
        userOrganizations: userOrganizations(state),
        currentUser: currentUser(state),
        notification: notificationSelectors.selectAll(state),
        showUpgradeDialog: showUpgradeDialog(state),
        showImportDialog: showImportDialog(state),
        autoSync: autoSync(state),
        joyRide: !!currentRide,
        sspFields: getClientSSPFields(state),
    };

    if (currentRide) {
        const tour = allTours[currentRide];
        if (tour && tour.steps) {
            toReturn.steps = tour.steps;
            toReturn.currentRide = currentRide;
        }
    }

    return toReturn;
}


CompactLayout.propTypes = {
    classes: PropTypes.shape({}).isRequired,
    children: PropTypes.shape({}).isRequired,
    width: PropTypes.string.isRequired,
    toggleSidenavVariant: PropTypes.func.isRequired,
    setSidenavOpen: PropTypes.func.isRequired
};

export default compose(
    withRouter,
    withCookies,
    withWidth(),
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, {
        toggleSidenav,
        toggleSidenavVariant,
        setSidenavOpen,
        patchOrganization: (org) => ({ type: 'CURRENT_ORGANIZATION', response: org, status: 'success' })
    }))(CompactLayout);

